<template>
  <div>
    <Navbar type="bg-transparent-sticky" />
    <div class="hero-container-thin">
      <div class="hero-opacity" />
      <img class="hero-image" src="../assets/gdq_hero.jpg" alt="hero image" />
    </div>
    <Breadcrumb />
    <div class="container-xl">
      <div class="title-area">
        <div class="d-flex">
          <div class="pr-4">
            <div class="survey-type-badge btn-primary">
              <fa-icon name="graduation-cap" />
            </div>
          </div>
          <h1 class="h2">
            {{ tutorial_heading }}
          </h1>
        </div>
      </div>
      <b-row>
        <div
          class="col-12 mr-2"
          v-html="tutorial_description"
        />
        <div class="col-12">
          <iframe
            :src="tutorial_link"
            width="640"
            height="360"
            frameborder="0"
            allow="autoplay;
            fullscreen"
            allowfullscreen
          />
        </div>
      </b-row>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue'
import Breadcrumb from './Breadcrumb.vue'

export default {
  name: 'Tutorial',
  components: {
    Navbar,
    Breadcrumb
  },
  data: function () {
    return {
      tutorial_id: this.$store.state.currenttutorial_id,
      tutorial_heading: null,
      tutorial_description: null,
      tutorial_link: null
      //      tutorial_link: "https://player.vimeo.com/video/292552820?title=0&byline=0&portrait=0",
    }
  },
  created () {
    this.tutorial_get()
  },
  methods: {
    tutorial_get () {
      this.$store.dispatch('tutorial_fetch', { tutorial_id: this.tutorial_id })
        .then((resp) => {
          this.tutorial_heading = resp.data.tutorial_heading
          this.tutorial_description = resp.data.tutorial_description
          this.tutorial_link = resp.data.tutorial_link
        })
    }
  }
}
</script>
<style>
</style>
